"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiConfig_1 = require("../config/ApiConfig");
var ApiManager_1 = require("../ApiManager");
var ApiEpisode = /** @class */ (function (_super) {
    __extends(ApiEpisode, _super);
    function ApiEpisode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_EPISODE_DATA = '/api/v1/page/episode';
        _this.GET_VIEWER_DATA = '/api/v1/page/viewer';
        _this.IS_USABLE_EPISODE = '/check/isUsableEpisode';
        _this.PURCHASE_EPISODE = '/api/v1/episode/purchase';
        _this.UNLOCK_ALL_EPISODE = '/api/v1/unlockAll/purchase';
        _this.SET_LIKE = '/api/v1/episode/setLike';
        _this.DEL_LIKE = '/api/v1/episode/delLike';
        /**
         * 회차리스트 api
         * @param token : 로그인 상태 인증값
         * @param comic : comic ID
         * @param is17 : 17금 파트너코드를 사용하고 있는지
         * @param isAlreadyMature : 사전인증 상태
         * @returns :
         *  comic: 만화정보,
         *  episodeList: 회차리스트 정보
         */
        _this.getEpisodeData = function (token, comic, is17, isAlreadyMature) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, is17: is17, isAlreadyMature: isAlreadyMature },
                method: 'get',
                url: _this.GET_EPISODE_DATA,
                params: { comicId: comic },
            });
        };
        /**
         * 회차 api
         * @param token
         * @param comic
         * @param episode
         * @param cToken
         * @returns
         */
        _this.getViewerData = function (token, comic, episode, isAlreadyMature, viewerToken, cToken) {
            var data = {
                comicId: comic,
                episodeId: episode,
                viewerToken: viewerToken !== null && viewerToken !== void 0 ? viewerToken : '',
                cToken: cToken !== null && cToken !== void 0 ? cToken : '',
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token, isAlreadyMature: isAlreadyMature },
                method: 'post',
                url: _this.GET_VIEWER_DATA,
                data: data,
            });
        };
        /**
         * 회차 클릭시 다음 액션에 대한 체크 api
         * @param token
         * @param comicId
         * @param episodeId
         * @location 호출 위치
         * @action 호출시 동작
         */
        _this.apiIsUsableEpisode = function (token, comicId, episodeId, location, action, purchaseType) {
            if (purchaseType === void 0) { purchaseType = ''; }
            var params = {
                comicId: comicId,
                episodeId: episodeId,
                location: location,
                action: action,
                purchaseType: purchaseType,
            };
            if (purchaseType === '') {
                delete params.purchaseType;
            }
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'get',
                url: _this.IS_USABLE_EPISODE,
                params: params,
            });
        };
        /**
         * 코인 소진 처리 api (성공시 뷰어로 진입)
         * @param token
         * @param comicId
         * @param episodeId
         */
        _this.purchaseEpisode = function (token, comicId, episodeId, purchaseType) {
            if (purchaseType === void 0) { purchaseType = ''; }
            var data = {
                comicId: comicId,
                episodeId: episodeId,
                purchaseType: purchaseType,
            };
            if (purchaseType === '') {
                delete data.purchaseType;
            }
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.PURCHASE_EPISODE,
                data: data,
            });
        };
        /**
         * 전체 구매 처리 api
         * @param token
         * @param comicId
         * @param type : coin(유료만) / all(무료포함)
         */
        _this.unlockAllEpisode = function (token, comicId, type) {
            var data = {
                comicId: comicId,
                type: type,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.UNLOCK_ALL_EPISODE,
                data: data,
            });
        };
        /**
         * 회차리스트 좋아요 api
         * @param token
         * @param comicId
         * @param episodeId
         * @param isLike
         * @returns
         */
        _this.updateEpisodeLike = function (token, comicId, episodeId, isLike) {
            var data = {
                comicId: comicId,
                episodeId: episodeId,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: isLike ? _this.SET_LIKE : _this.DEL_LIKE,
                data: data,
            });
        };
        return _this;
    }
    ApiEpisode.getInstance = function (initValue) {
        if (!ApiEpisode.classInstance) {
            this.classInstance = new ApiEpisode(initValue);
        }
        return this.classInstance;
    };
    return ApiEpisode;
}(ApiManager_1.ApiManager));
exports.default = ApiEpisode;
